import { combineReducers } from 'redux';
import headline  from './headline';
import name  from './name';
import picture  from './picture';
import locations  from './locations';
import industries from './industries';
import ui from './ui';
import summary from './summary';
import experience from './experience';
import endorsements from './endorsements';
import education from './education';
import certificates from './certificates';
import press from './press';
import awards from './awards';
import publications from './publications';
import forms from './forms';
import customUrl from './url';
import visibility from './visibility';
import guest from './guest';
import expertise from './expertise';
import sectors from './sectors';
import markets from './markets';
import permissions from './permissions';
import investments from './investments';
import rating from './rating';
import profileComplete from './profile-complete';

const profileCombined = combineReducers( {
    headline,
    name,
    picture,
    locations,
    ui,
    summary,
    experience,
    endorsements,
    education,
    certificates,
    press,
    awards,
    publications,
    industries,
    forms,
    customUrl,
    visibility,
    guest,
    expertise,
    sectors,
    markets,
    permissions,
    investments,
    rating,
    profileComplete,
});

const destroyProfile = (state, action) => {
    if ( action.type === "DESTROY_PROFILE") {
        state = undefined;
    }
    return profileCombined( state, action )
}

export default destroyProfile;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/index.js